import { render } from "./ProfileLayoutMinimalProfile.vue?vue&type=template&id=66d6099c&scoped=true"
import script from "./ProfileLayoutMinimalProfile.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutMinimalProfile.vue?vue&type=script&lang=js"

import "./ProfileLayoutMinimalProfile.vue?vue&type=style&index=0&id=66d6099c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d6099c"]])

export default __exports__